export default {
  name: 'home'
}
